import { localMoment, timezone } from "@/common/date";

export function exportCsv(
  json: any[],
  csvHeader: string[],
  fileName: string,
  isEventList = false,
): void {
  const data: any[] = [];
  json = json.map((elm: any) => {
    data.push({
      name: elm.Name,
      data: elm.data,
      periode: elm.periode,
      sampling: elm.Sampling,
      samplingUnit: elm.SamplingUnit,
    });
    delete elm.data;
    delete elm.periode;
    return elm;
  });
  let dataLigneTitle = "";
  let dataTitles = "";

  for (const elm of data) {
    dataLigneTitle = `${dataLigneTitle}Date:;data:;;;`;
    dataTitles = `${dataTitles}${elm.name}:;;;;`;
  }

  const fields = Object.keys(json[0]);
  const replacer = function (_key: any, value: any) {
    return value === null ? "" : value;
  };
  const csvElements = [
    ...csvHeader,
    fields.join(";"),
    ...json.map((row: any) => {
      return fields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(";");
    }),
  ];

  csvElements.push(``);
  if (!isEventList) {
    csvElements.push(` Variables data:;`);
    csvElements.push(dataTitles);
    csvElements.push(dataLigneTitle);
    for (const dataIndex in data[0].data) {
      let dataLigne = "";
      for (const elm of data) {
        dataLigne = ` ${dataLigne}${localMoment(elm.data[dataIndex].date)
          .tz(timezone)
          .format("DD/MM/YYYY HH:mm:ss")}; ${elm.data[dataIndex].value};;; `;
      }
      csvElements.push(dataLigne);
    }
  }
  const csv = csvElements.join("\r\n");
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
  element.target = "_blank";
  element.download = `${fileName}.csv`;
  element.click();
}

export function exportTableCsv(
  json: any[],
  csvHeader: string[],
  fileName: string,
): void {
  const data: any[] = [...json];
  const csvElements = [
    ...csvHeader,
    `Name:;YTD:;MTD:;Current:;;;`,
    ...data.map((row: any) => {
      return `${row.name}; ${row.ytd}; ${row.mtd}; ${row.current};;; `;
    }),
  ];

  const csv = csvElements.join("\r\n");
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
  element.target = "_blank";
  element.download = `${fileName}.csv`;
  element.click();
}

interface VariableData {
  Client?: string;
  Site?: string;
  Project?: string;
  Name?: string;
  Unit?: string;
  AcquisitionDevice?: string;
  IdTechnique?: string;
  Type?: string;
  Aggregation?: string;
  Attached?: string;
  [key: string]: any;
}

export function exportVariablesTableCsv(
  json: VariableData[],
  fileName: string,
  columnsPreferences: string[],
): void {
  const orderedKeys: string[] = [
    "Client",
    "Site",
    "Project",
    "Name",
    "Unit",
    "AcquisitionDevice",
    "IdTechnique",
    "Type",
    "Aggregation",
    "Attached",
    "Duration",
    "Continuity",
  ];
  const filteredData: VariableData[] = json.map((elm: VariableData) => {
    const orderedElm: VariableData = {};
    orderedKeys.forEach((key) => {
      if (elm[key] !== undefined) {
        orderedElm[key] = elm[key];
      }
    });
    return orderedElm;
  });

  for (const elm of filteredData) {
    if (!columnsPreferences.includes("client")) delete elm.Client;
    if (!columnsPreferences.includes("place")) delete elm.Site;
    if (!columnsPreferences.includes("project")) delete elm.Project;
    if (!columnsPreferences.includes("variableName")) delete elm.Name;
    if (!columnsPreferences.includes("unity")) delete elm.Unit;
    if (!columnsPreferences.includes("acquisitionDevice"))
      delete elm.AcquisitionDevice;
    if (!columnsPreferences.includes("sourceTechnicalName"))
      delete elm.IdTechnique;
    if (!columnsPreferences.includes("variableType")) delete elm.Type;
    if (!columnsPreferences.includes("aggregation")) delete elm.Aggregation;
    if (!columnsPreferences.includes("attached")) delete elm.Attached;
    if (!columnsPreferences.includes("duration")) delete elm.Duration;
    if (!columnsPreferences.includes("continuity")) delete elm.Continuity;
  }

  const fields = orderedKeys.filter(
    (key) => filteredData[0][key] !== undefined,
  );

  const csvElements = [
    fields.join(";"),
    ...filteredData.map((row: VariableData) => {
      return fields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName]);
        })
        .join(";");
    }),
  ];

  const csv = csvElements.join("\r\n");
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
  element.target = "_blank";
  element.download = `${fileName}.csv`;
  element.click();
}

export function exportEventsTableCsv(
  json: any[],
  fileName: string,
  columnsPrefernces: string[],
): void {
  json = json.map((elm: any) => {
    if (!columnsPrefernces.includes("client")) delete elm.Client;
    if (!columnsPrefernces.includes("place")) delete elm.Site;
    if (!columnsPrefernces.includes("project")) delete elm.Project;
    if (!columnsPrefernces.includes("alertName")) delete elm.Alert;
    if (!columnsPrefernces.includes("variableName")) delete elm.Variable;
    if (!columnsPrefernces.includes("sourceTechnicalName"))
      delete elm.IdTechnique;
    if (!columnsPrefernces.includes("alertLevelName")) delete elm.Criticite;
    if (!columnsPrefernces.includes("dateStart")) delete elm.Debut;
    if (!columnsPrefernces.includes("dateEnd")) delete elm.Fin;
    if (!columnsPrefernces.includes("status")) delete elm.Status;
    return elm;
  });

  const fields = Object.keys(json[0]);
  const replacer = function (_key: any, value: any) {
    return value === null ? "" : value;
  };

  const csvElements = [
    fields.join(";"),
    ...json.map((row: any) => {
      return fields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(";");
    }),
  ];

  csvElements.push(``);

  const csv = csvElements.join("\r\n");
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
  element.target = "_blank";
  element.download = `${fileName}.csv`;
  element.click();
}

export function exportAlertsTableCsv(
  json: any[],
  fileName: string,
  columnsPrefernces: string[],
): void {
  json = json.map((elm: any) => {
    if (!columnsPrefernces.includes("client")) delete elm.Client;
    if (!columnsPrefernces.includes("place")) delete elm.Site;
    if (!columnsPrefernces.includes("project")) delete elm.Project;
    if (!columnsPrefernces.includes("alertName")) delete elm.Alert;
    if (!columnsPrefernces.includes("variableName")) delete elm.Variable;
    if (!columnsPrefernces.includes("sourceTechnicalName"))
      delete elm.IdTechnique;
    if (!columnsPrefernces.includes("alertLevelName")) delete elm.Criticite;
    if (!columnsPrefernces.includes("alertType")) delete elm.Type;
    if (!columnsPrefernces.includes("scenarios")) delete elm.Scenario;
    if (!columnsPrefernces.includes("threshold")) delete elm.Seuil;
    if (!columnsPrefernces.includes("contactsName"))
      delete elm.NotifiedContacts;
    if (!columnsPrefernces.includes("contactsEmail")) delete elm.EmailContacts;

    return elm;
  });

  const fields = Object.keys(json[0]);
  const replacer = function (_key: any, value: any) {
    return value === null ? "" : value;
  };

  const csvElements = [
    fields.join(";"),
    ...json.map((row: any) => {
      return fields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(";");
    }),
  ];

  csvElements.push(``);

  const csv = csvElements.join("\r\n");
  const element = document.createElement("a");
  element.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
  element.target = "_blank";
  element.download = `${fileName}.csv`;
  element.click();
}
